import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { api } from '../../../services';

import FMToolbar from './FMToolbar';
import FMTable from './FMTable';
import FMFormModal from './FMFormModal';
import FMAssetBindingModal from './FMAssetBindingModal';

import './FleetManagers.css';

@inject('translationsStore')
@observer
class FleetManagers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      fleetManagers: [],
      submitError: undefined,
      createLoading: false,
      createModalVisible: false,
      editLoading: false,
      editModalVisible: false,
      bindingLoading: false,
      bindingModalVisible: false,
      fleetManagerId: undefined,
      combinedAssets: [],
      availableAssets: [],
      assignedAssets: [],
      dataSource: [],
      targetKeys: [],
      fleetManagerFormData: {}
    };
  }

  componentDidMount() {
    this.loadData();
  }

  loadData() {
    this.setState({ loading: true });
    return api('getFleetManagers').then(fleetManagers => {
      fleetManagers = fleetManagers.map(fm => ({ ...fm, key: fm.uin }));
      this.setState({ fleetManagers, loading: false });
    });
  }

  promptCreateFleetManager = () => {
    this.setState({
      createModalVisible: true
    });
  };

  handleCreateFleetManager = data => {
    const { translationsStore } = this.props;
    this.setState({ createLoading: true, submitError: undefined });
    let submitError = undefined;
    let apiData = Object.assign({}, data);
    apiData.address = { street: apiData.address };
    this.removeEmpty(apiData);
    api('createFleetManager', apiData)
      .then(response => {
        this.loadData();
        this.hideCreateModal();
      })
      .catch(error => {
        submitError = translationsStore.translate('fleetManagers.create.error');
      })
      .then(response => {
        this.setState({ createLoading: false, submitError });
      });
  };

  cancelCreateFleetManager = () => {
    this.hideCreateModal();
  };

  hideCreateModal = () => {
    this.setState({
      createModalVisible: false,
      submitError: undefined
    });
  };

  promptEditFleetManager = fleetManagerId => {
    const { fleetManagers } = this.state;
    const fleetManagerFormData = fleetManagers.find(fm => fm.id === fleetManagerId);
    this.setState({
      editModalVisible: true,
      fleetManagerFormData,
      fleetManagerId
    });
  };

  removeEmpty = obj => {
    Object.keys(obj).forEach(key => {
      if (obj[key] && typeof obj[key] === 'object') {
        this.removeEmpty(obj[key]);
      } else if (obj[key] === null || obj[key] === undefined || obj[key] === '') {
        delete obj[key];
      }
    });
  };

  handleEditFleetManager = data => {
    const { translationsStore } = this.props;
    const { fleetManagerId } = this.state;
    this.setState({ editLoading: true, submitError: undefined });
    let submitError = undefined;
    let apiData = Object.assign({}, data);
    apiData.address = { street: apiData.address };
    this.removeEmpty(apiData);
    api('updateFleetManager', fleetManagerId, apiData)
      .then(response => {
        this.loadData();
        this.hideEditModal();
      })
      .catch(error => {
        submitError = translationsStore.translate('fleetManagers.edit.error');
      })
      .then(response => {
        this.setState({ editLoading: false, submitError });
      });
  };

  cancelEditFleetManager = () => {
    this.hideEditModal();
  };

  hideEditModal = () => {
    this.setState({
      editModalVisible: false,
      submitError: undefined
    });
  };

  promptAssetBinding = fleetManagerId => {
    let bindingModalVisible = false;
    let availableAssets = [];
    let assignedAssets = [];
    Promise.all([api('getAvailableAssets'), api('getFleetManagerAssets', fleetManagerId)])
      .then(([responseAvailableAssets, responseFleetManagerAssets]) => {
        availableAssets = (responseAvailableAssets || []).map(item => ({ id: item.id, imei: item.imei }));
        assignedAssets = (responseFleetManagerAssets || []).map(item => ({ id: item.id, imei: item.imei }));

        bindingModalVisible = true;
      })
      .catch(error => {
        console.error(error);
      })
      .then(response => {
        const combinedAssets = [].concat(availableAssets).concat(assignedAssets);
        const dataSource = combinedAssets.map(asset => ({
          key: asset.id,
          title: asset.imei,
          description: asset.imei
        }));
        const targetKeys = assignedAssets.map(asset => asset.id);

        this.setState({
          bindingModalVisible,
          fleetManagerId,

          combinedAssets,
          availableAssets,
          assignedAssets,

          dataSource,
          targetKeys
        });
      });
  };

  cancelAssetBinding = () => {
    this.hideAssetBindingCreateModal();
  };

  hideAssetBindingCreateModal = () => {
    this.setState({
      bindingModalVisible: false,
      fleetManagerId: undefined
    });
  };

  // asset binding
  onChange = (fleetManagerId, targetKeys, direction, moveKeys) => {
    const { translationsStore } = this.props;
    this.setState({ bindingLoading: true });
    let bindingError = undefined;
    let stateTargetKeys = this.state.targetKeys;
    const imeis = moveKeys.map(key => (this.state.combinedAssets.find(asset => asset.id === key) || {}).imei);
    if (direction === 'right') {
      //bind
      api('assignFleetManagerAssets', fleetManagerId, imeis)
        .then(response => {
          stateTargetKeys = targetKeys;
        })
        .catch(error => {
          bindingError = translationsStore.translate('fleetManagers.assetsBinding.error');
        })
        .then(response => {
          this.setState({ targetKeys: stateTargetKeys, bindingLoading: false, bindingError });
        });
    }
    if (direction === 'left') {
      //unbind
      api('unassignFleetManagerAssets', fleetManagerId, imeis)
        .then(response => {
          stateTargetKeys = targetKeys;
        })
        .catch(error => {
          bindingError = translationsStore.translate('fleetManagers.assetsBinding.error');
        })
        .then(response => {
          this.setState({ targetKeys: stateTargetKeys, bindingLoading: false, bindingError });
        });
    }
  };

  render() {
    const { translationsStore } = this.props;
    const fleetManager = this.state.fleetManagers.filter(fleetManager => fleetManager.id === this.state.fleetManagerId).shift();
    return (
      <div className="FleetManagers">
        <FMToolbar onCreate={this.promptCreateFleetManager} />
        <FMTable loading={this.state.loading} dataSource={this.state.fleetManagers} onEdit={this.promptEditFleetManager} assetBinding={this.promptAssetBinding} />
        <FMFormModal
          className="FMFormModal"
          visible={this.state.createModalVisible}
          loading={this.state.createLoading}
          submitLabel={translationsStore.translate('fleetManagers.create.modal.labelCreate')}
          onSubmit={this.handleCreateFleetManager}
          onCancel={this.cancelCreateFleetManager}
          submitError={this.state.submitError}
        />
        <FMFormModal
          className="FMFormModal"
          visible={this.state.editModalVisible}
          loading={this.state.editLoading}
          submitLabel={translationsStore.translate('fleetManagers.edit.modal.labelEdit')}
          onSubmit={this.handleEditFleetManager}
          onCancel={this.cancelEditFleetManager}
          submitError={this.state.submitError}
          data={this.state.fleetManagerFormData}
        />
        <FMAssetBindingModal
          visible={this.state.bindingModalVisible}
          onOk={() => {}}
          onCancel={this.cancelAssetBinding}
          dataSource={this.state.dataSource}
          targetKeys={this.state.targetKeys}
          loading={this.state.bindingLoading}
          bindingError={this.state.bindingError}
          fleetManagerId={this.state.fleetManagerId}
          fleetManager={fleetManager}
          onChange={this.onChange}
        />
      </div>
    );
  }
}

export default FleetManagers;
